// Bambody v3 landing page interactivity — parallax, layer diagram, wear/wash tabs,
// sizing table interactions, newsletter feedback, sticky bottom bar, scroll reveals.
// Shop section is handled by bambody-v2-shop (real Shopify products); this file skips
// the v3 HTML's demo shop JS entirely.

(function () {
  // ── PARALLAX ──
  window.addEventListener('scroll', () => {
    const y = window.scrollY
    const blob = document.getElementById('bam-v3-hero-blob')
    const img = document.getElementById('bam-v3-hero-img')
    const fbTop = document.getElementById('bam-v3-fb-top')
    const fbBot = document.getElementById('bam-v3-fb-bot')
    if (blob && y < 800) {
      blob.style.transform = `translateY(${y * 0.04}px)`
      if (img) img.style.transform = `translateY(${y * 0.06}px)`
      if (fbTop) fbTop.style.transform = `translateY(${y * 0.03}px)`
      if (fbBot) fbBot.style.transform = `translateY(${y * -0.02}px)`
    }
    // Sticky bar visibility.
    //   Homepage: show once the shop section's bottom scrolls past the viewport top.
    //   PDP:      show once the main ATC button scrolls off-screen; hide when it's back in view.
    //   Fallback: show after 800px scroll, hide when back near the top.
    const shopSec = document.getElementById('bam-v3-shop') || document.getElementById('bam-v3-shop-anchor')
    const pdpAtc = document.getElementById('bam-v3-pdp-atc-btn')
    const sb = document.getElementById('bam-v3-sticky-bar')
    if (sb) {
      if (shopSec) {
        const r = shopSec.getBoundingClientRect()
        if (r.bottom < 0) sb.classList.add('visible')
        else sb.classList.remove('visible')
      } else if (pdpAtc) {
        const r = pdpAtc.getBoundingClientRect()
        // Show when the on-page ATC is scrolled above the viewport top; hide once it's visible again.
        if (r.bottom < 0) sb.classList.add('visible')
        else sb.classList.remove('visible')
      } else if (y > 800) {
        sb.classList.add('visible')
      } else {
        sb.classList.remove('visible')
      }
    }
  }, { passive: true })

  // ── LAYER DIAGRAM ──
  const layerData = [
    { icon: '🩹', bg: '#FEE6FF', title: 'Soft outer layer', desc: 'Silky bamboo rayon sits directly against your skin. Hypoallergenic and breathable — gentle on sensitive, postpartum, and hormonal skin. This is the layer that makes Bambody feel nothing like a pad.' },
    { icon: '💧', bg: '#EEEDFE', title: 'Moisture-wicking layer', desc: 'Pulls moisture away from your skin in seconds using a tight-weave bamboo structure. You stay dry and comfortable even on heavier days or during exercise.' },
    { icon: '🔒', bg: '#E6F1FB', title: 'Absorbent core', desc: 'Multiple slim absorbent layers lock blood away from your skin. The core holds its capacity through 200+ washes when properly cared for — no degradation over time.' },
    { icon: '🛡️', bg: '#EFF6F0', title: 'Leak-proof barrier', desc: 'A waterproof backing prevents any leaks through to clothes or bedding. No PFAS chemicals used — tested safe for skin contact to OEKO-TEX standards.' },
  ]
  window.bamV3SetLayer = function (i) {
    document.querySelectorAll('.bam-v3 .layer-viz').forEach((el, idx) => el.classList.toggle('active', idx === i))
    const d = layerData[i]
    const icon = document.getElementById('bam-v3-ld-icon')
    const title = document.getElementById('bam-v3-ld-title')
    const desc = document.getElementById('bam-v3-ld-desc')
    if (icon) { icon.style.background = d.bg; icon.innerHTML = `<span style="font-size:20px">${d.icon}</span>` }
    if (title) title.textContent = d.title
    if (desc) desc.textContent = d.desc
  }

  // ── SIZING ──
  const SIZES = [
    { size: 'XS', waist: '25–26"', hip: '33–35"' },
    { size: 'S', waist: '27–28"', hip: '36–37"' },
    { size: 'M', waist: '29–31"', hip: '38–39"' },
    { size: 'L', waist: '32–34"', hip: '40–41"' },
    { size: 'XL', waist: '35–37"', hip: '42–43"' },
    { size: 'XXL', waist: '38–41"', hip: '44–45"' },
    { size: '3XL', waist: '42–45"', hip: '46–47"' },
    { size: '4XL', waist: '46–49"', hip: '48–49"' },
    { size: '5XL', waist: '—', hip: '50–51"' },
    { size: '6XL', waist: '—', hip: '51–52"' },
  ]
  const sizeState = { sel: 'M' }
  function renderSizeTable() {
    const el = document.getElementById('bam-v3-size-table')
    if (!el) return
    el.innerHTML = SIZES.map((z) =>
      `<button type="button" class="sz-row${sizeState.sel === z.size ? ' active' : ''}" onclick="bamV3PickSize('${z.size}')">` +
      `<span class="sz-label">${z.size}</span>` +
      `<span style="color:#5b5266">${z.waist}</span>` +
      `<span style="color:#5b5266">${z.hip}</span>` +
      `</button>`,
    ).join('')
  }
  // Look up waist/hip from SIZES by size — passing them inline in onclick broke the
  // HTML attribute because the inch marks (") closed the onclick="" quote early.
  window.bamV3PickSize = function (sz) {
    const z = SIZES.find((s) => s.size === sz)
    if (!z) return
    const w = z.waist, h = z.hip
    sizeState.sel = sz
    const big = document.getElementById('bam-v3-size-big')
    if (big) {
      big.style.transform = 'scale(1.2)'
      setTimeout(() => (big.style.transform = ''), 180)
      big.textContent = sz
    }
    const waist = document.getElementById('bam-v3-sel-waist')
    const hip = document.getElementById('bam-v3-sel-hip')
    const rec = document.getElementById('bam-v3-size-rec')
    const cta = document.getElementById('bam-v3-size-cta')
    if (waist) waist.textContent = w
    if (hip) hip.textContent = h
    if (rec) rec.textContent = `Your everyday hipster in size ${sz}.`
    if (cta) cta.innerHTML = `Shop size ${sz} <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`
    renderSizeTable()
  }

  // ── WEAR/WASH TABS ──
  window.bamV3SwitchTab = function (tab, btn) {
    document.querySelectorAll('.bam-v3 .ww-tab').forEach((t) => t.classList.remove('active'))
    btn.classList.add('active')
    document.querySelectorAll('.bam-v3 .ww-panel').forEach((p) => p.classList.remove('active'))
    const panel = document.getElementById('bam-v3-panel-' + tab)
    if (panel) panel.classList.add('active')
    document.querySelectorAll('#bam-v3-panel-' + tab + ' .stagger').forEach((el) => {
      el.classList.remove('visible')
      requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('visible')))
    })
  }

  // ── NEWSLETTER ──
  window.bamV3HandleSub = function (e) {
    e.preventDefault()
    const btn = document.getElementById('bam-v3-sub-btn')
    if (btn) { btn.textContent = '✓ Code sent!'; btn.style.background = '#4f9e6d' }
  }

  // ── SCROLL REVEAL ──
  document.addEventListener('DOMContentLoaded', () => {
    renderSizeTable()
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('visible') })
    }, { threshold: 0.07 })
    document.querySelectorAll('.bam-v3 .reveal, .bam-v3 .reveal-l, .bam-v3 .reveal-r, .bam-v3 .stagger').forEach((el) => obs.observe(el))

    // Absorbency bars
    const absObs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setTimeout(() => {
          const reg = document.getElementById('bam-v3-bar-reg')
          const night = document.getElementById('bam-v3-bar-night')
          if (reg) reg.style.width = '50%'
          if (night) night.style.width = '100%'
        }, 200)
        absObs.disconnect()
      }
    }, { threshold: 0.3 })
    const howSec = document.getElementById('bam-v3-how')
    if (howSec) absObs.observe(howSec)

    setTimeout(() => {
      const hs = document.querySelector('.bam-v3 .hero-stats')
      if (hs) hs.classList.add('visible')
    }, 300)
  })

  // Smooth scroll helper. The shop anchor only exists on the homepage, so on every
  // other page (about, why-bambody, care-guide…) the "Shop"/"Make the switch" CTAs
  // that call this would be dead — fall back to navigating to /pages/shop.
  window.bamV3SmoothTo = function (id) {
    const el = document.getElementById(id)
    if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return }
    if (id === 'bam-v3-shop-anchor' || id === 'bam-v3-shop' || id === 'shop') {
      window.location.href = '/pages/shop'
    }
  }

  // ── HOW IT WORKS — scroll-driven 4-layer highlight + click-to-pin ──
  // In static mode (homepage), the CSS shows all 4 boxes active; JS wires
  // hover-to-highlight the specific dot/line for the hovered box only.
  document.addEventListener('DOMContentLoaded', () => {
    const frame = document.querySelector('[data-bam-how]')
    if (!frame) return
    const section = document.getElementById('bam-v3-how')
    if (!section) return
    const track = section.firstElementChild
    const lines = frame.querySelectorAll('[data-line]')
    const dots = frame.querySelectorAll('[data-dot]')
    const boxes = frame.querySelectorAll('[data-box]')
    const isStatic = section.hasAttribute('data-bam-how-static')
    const state = { layer: 1, pinned: false, timer: 0 }

    const applyLayer = (n) => {
      state.layer = n
      lines.forEach((el) => (el.dataset.line === String(n) ? el.setAttribute('data-active', '') : el.removeAttribute('data-active')))
      dots.forEach((el) => (el.dataset.dot === String(n) ? el.setAttribute('data-active', '') : el.removeAttribute('data-active')))
      boxes.forEach((el) => (el.dataset.box === String(n) ? el.setAttribute('data-active', '') : el.removeAttribute('data-active')))
    }

    if (isStatic) {
      // Homepage: no sticky scroll. Layer 1 active by default; hover a box to focus that layer.
      applyLayer(1)
      boxes.forEach((el) => {
        const n = Number(el.dataset.box)
        el.addEventListener('mouseenter', () => applyLayer(n))
      })
      return
    }

    const onScroll = () => {
      if (state.pinned) return
      const r = track.getBoundingClientRect()
      const span = r.height - window.innerHeight
      if (span <= 0) return
      const p = Math.min(1, Math.max(0, -r.top / span))
      const n = Math.min(4, Math.floor(p * 4) + 1)
      if (n !== state.layer) applyLayer(n)
    }

    boxes.forEach((el) => {
      el.addEventListener('click', () => {
        applyLayer(Number(el.dataset.box))
        state.pinned = true
        clearTimeout(state.timer)
        state.timer = setTimeout(() => { state.pinned = false; onScroll() }, 2500)
      })
    })

    window.addEventListener('scroll', onScroll, { passive: true })
    applyLayer(1)
    onScroll()
  })

  // ── WEAR & CARE — tab (wear/wash) + card focus ──
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('bam-v3-care')
    if (!root) return
    const tabs = root.querySelectorAll('[data-bam-care-tabs] .bam-v3-care__tab')
    const grids = root.querySelectorAll('[data-bam-care-grid]')
    const headline = root.querySelector('[data-bam-care-headline]')
    const HEADLINES = { wear: 'Wearing it is the easy part', wash: 'Washes like everything else' }

    function focusCard(grid, n) {
      grid.querySelectorAll('.bam-v3-care__card').forEach((c) => {
        c.classList.toggle('is-active', Number(c.dataset.step) === n)
      })
    }
    function setMode(mode) {
      tabs.forEach((t) => {
        const on = t.dataset.mode === mode
        t.classList.toggle('is-active', on)
        t.setAttribute('aria-selected', on ? 'true' : 'false')
      })
      grids.forEach((g) => {
        const on = g.dataset.mode === mode
        if (on) g.removeAttribute('hidden')
        else g.setAttribute('hidden', '')
        if (on) focusCard(g, 1)
      })
      if (headline && HEADLINES[mode]) headline.textContent = HEADLINES[mode]
    }
    tabs.forEach((t) => t.addEventListener('click', () => setMode(t.dataset.mode)))
    // Expose: scroll to the wear/care widget and open a given tab (used by care-guide contrast cards + jump menu).
    window.bamV3CareShow = function (mode) {
      if (mode) setMode(mode)
      root.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    grids.forEach((g) => {
      g.querySelectorAll('.bam-v3-care__card').forEach((c) => {
        const focus = () => focusCard(g, Number(c.dataset.step))
        c.addEventListener('mouseenter', focus)
        c.addEventListener('click', focus)
      })
    })
  })

  // ── MOBILE DRAWER (nav hamburger → right-side slide drawer) ──
  // Wires the button/scrim/close in sections/bambody-v2-header.liquid.
  // Idempotent — safe to run once on DOMContentLoaded.
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('[data-bam-drawer]')
    const scrim = document.querySelector('[data-bam-drawer-scrim]')
    const openBtn = document.querySelector('[data-bam-drawer-open]')
    if (!drawer || !scrim || !openBtn) return

    const closeEls = drawer.querySelectorAll('[data-bam-drawer-close]')
    const focusables = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
    let lastFocused = null

    const openDrawer = () => {
      lastFocused = document.activeElement
      drawer.hidden = false
      scrim.hidden = false
      // Force a paint so the transition catches — hidden→visible in the same frame skips animation.
      requestAnimationFrame(() => {
        drawer.setAttribute('data-open', '')
        scrim.setAttribute('data-open', '')
      })
      openBtn.setAttribute('aria-expanded', 'true')
      document.documentElement.classList.add('bam-v2-drawer-open')
      const main = document.querySelector('main, #MainContent')
      if (main) main.setAttribute('inert', '')
      // Move focus to the close button for keyboard users.
      const closeBtn = drawer.querySelector('[data-bam-drawer-close]')
      if (closeBtn) closeBtn.focus()
    }

    const closeDrawer = () => {
      drawer.removeAttribute('data-open')
      scrim.removeAttribute('data-open')
      openBtn.setAttribute('aria-expanded', 'false')
      document.documentElement.classList.remove('bam-v2-drawer-open')
      const main = document.querySelector('main, #MainContent')
      if (main) main.removeAttribute('inert')
      // Wait for the transition to end before hiding, so focus doesn't jump mid-animation.
      setTimeout(() => {
        drawer.hidden = true
        scrim.hidden = true
      }, 340)
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus()
    }

    openBtn.addEventListener('click', openDrawer)
    scrim.addEventListener('click', closeDrawer)
    closeEls.forEach((el) => el.addEventListener('click', closeDrawer))
    // Close when any link inside the drawer is tapped (SPA-like feel; page will still navigate).
    drawer.querySelectorAll('a[href]').forEach((a) => a.addEventListener('click', () => closeDrawer()))

    // ESC + basic focus trap.
    document.addEventListener('keydown', (e) => {
      if (drawer.hidden) return
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return }
      if (e.key !== 'Tab') return
      const list = drawer.querySelectorAll(focusables)
      if (!list.length) return
      const first = list[0]
      const last = list[list.length - 1]
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus() }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus() }
    })

    // Auto-close on viewport widen past mobile breakpoint (avoid stuck-open state on rotate).
    const mql = window.matchMedia('(min-width: 901px)')
    mql.addEventListener?.('change', (e) => { if (e.matches && !drawer.hidden) closeDrawer() })
  })
})();
